import Vue from "vue"
/* import backlinksApi from "../../api/backlinks" */
import utilsApi from "../../api/utils"
//import axios from "axios"

const initialObject = {
  _id: undefined,
  name: undefined,
  //value: undefined,
  to: undefined,
  from: undefined,
  status: undefined,
  type: undefined,
  createdAt: undefined,
  updatedAt: undefined
}
const ignoreObjectsFields = ["createdAt", "updatedAt"]
// general state for the site

/* const typeValue = {
  typeD: ""
}
 */
const initialState = {
  backlinks: [],
  count: 0,
  page: 1,
  fetched: false,
  error: false,
  object: initialObject,
  isNew: false,
  selected: []
}

const state = Object.assign({}, initialState)

const getters = {
  backlinks: (state) => state.backlinks,
  //backlinks: () => backlinks,
  backlinksIndex: (state) => (payload) => {
    //console.log(state.backlinks)
    const { param, parent, key } = payload || {}
    return payload
      ? param
        ? key
          ? parent
            ? state[param] && state[param][parent] && state[param][parent][key]
              ? state[param][parent][key]
              : undefined
            : state[param] && state[param][key]
            ? state[param][key]
            : undefined
          : state[param]
          ? state[param]
          : undefined
        : state
      : state
  },
  backlinksError: (state) => state.error,
  backlinks_Object: (state) => state.object,
  backlinks_isNew: (state) => state.isNew,
  backlinks_selected: (state) => state.selected
}
const actions = {
  UPDATE_state({ commit }, payload) {
    commit("SET_backlinks", payload)
    return true
  },

  async DELETE_backlinks({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.deleteObject("backlinks", object)
    if (apiResponse != null) {
      //commit("BACKLINKS_SETTING", apiResponse)
      dispatch("FETCH_PAGE_backlinks", state.page)
      return true
    } else {
      commit("BACKLINKS_ERROR")
      return false
    }
  },
  async DELETE_SELECTED_backlinks({ state, dispatch, commit }) {
    let deletions = await Promise.all(
      state.selected.map(async (current) => {
        return await dispatch("DELETE_backlinks", current)
      })
    )
    if (deletions.includes(false)) {
      return false
    } else {
      commit("SET_backlinks", {
        param: "selected",
        value: []
      })
      return true
    }
  },
  UPDATE_backlinksState({ commit }, payload) {
    commit("SET_backlinks", payload)
    //console.log("payload UPDATE", payload)
    return true
  },
  async UPDATE_backlinks({ commit, dispatch, state }, object) {
    const filtered = Object.keys(object)
      .filter((key) => !ignoreObjectsFields.includes(key))
      .reduce((obj, key) => {
        obj[key] = object[key]
        return obj
      }, {})
    let apiResponse = await utilsApi.updateObject("backlinks", filtered)
    if (apiResponse != null) {
      commit("BACKLINKS_SETTING", apiResponse)
      dispatch("FETCH_PAGE_backlinks", state.page)
      return true
    } else {
      commit("BACKLINKS_ERROR")
      return false
    }
  },
  async CREATE_backlinks({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.createObject("backlinks", object)
    //console.log("Objeto creado BACKLINK", object)
    if (apiResponse != null) {
      commit("SET_backlinks", {
        param: "object",
        value: apiResponse.backlink
      })
      dispatch("FETCH_PAGE_backlinks", state.page)
      return true
    } else {
      commit("BACKLINKS_ERROR")
      return false
    }
  },
  async FETCH_backlinks({ commit }) {
    let apiResponse = await utilsApi.getObjects("backlinks")
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("BACKLINKS_SETTING", apiResponse)
      return true
    } else {
      commit("BACKLINKS_ERROR")
      return false
    }
  },

  async FETCH_PAGE_backlinks({ commit }, page) {
    let apiResponse = await utilsApi.getObjectsPage("backlinks", page)
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("BACKLINKS_SETTING", { ...apiResponse, page })
      return true
    } else {
      commit("BACKLINKS_ERROR")
      return false
    }
  },

  UPDATE_OBJECT_backlinks({ commit }, payload) {
    commit("SET_OBJECT_BACKLINK", payload)
    return true
  },
  CLEAN_OBJECT_backlinks({ commit }) {
    commit("SET_OBJECT_BACKLINK_INITIAL")
    return true
  },
  async CLEAN_STORE_backlinks({ commit }) {
    const initialStateKeys = Object.keys(initialState)
    await Promise.all(
      initialStateKeys.map(async (current) => {
        await commit("SET_backlinks", {
          param: current,
          value: initialState[current]
        })
        return true
      })
    )
    return true
  },
  UPDATE_SELECTED_backlinks({ commit }, payload) {
    commit("SET_SELECTED_BACKLINKS", payload)
    return true
  }
}
const mutations = {
  BACKLINKS_SETTING: (state, { backlinks, count = false, page }) => {
    //console.log("CHECK STATE", backlinks)
    state.count = count || state.backlinks.length
    state.page = page || state.page
    state.backlinks = backlinks
    state.fetched = true
    state.error = false
  },
  BACKLINKS_ERROR: (state) => {
    state.backlinks = null
    state.fetched = true
    state.error = false
  },
  SET_OBJECT_BACKLINK: (state, payload) => {
    Object.keys(initialObject).map((key) => {
      state.object[key] = payload[key]
    })
  },
  SET_OBJECT_BACKLINK_INITIAL: (state) => {
    state.object = { ...state.object, ...initialObject }
  },
  SET_SELECTED_BACKLINKS: (state, selectedBacklinks) => {
    state.selected = selectedBacklinks
  },
  SET_backlinks: (state, payload) => {
    const { param, parent, key, value } = payload
    //console.log("SETTING FORMS STATE IN", param, value, key, parent)
    key
      ? parent
        ? state[param]
          ? state[param][parent]
            ? Vue.set(state[param][parent], key, value)
            : Vue.set(state[param], parent, {}) &&
              Vue.set(state[param][parent], key, value)
          : Vue.set(state, param, {}) &&
            Vue.set(state[param], parent, {}) &&
            Vue.set(state[param][parent], key, value)
        : state[param]
        ? Vue.set(state[param], key, value)
        : Vue.set(state, param, {}) && Vue.set(state[param], key, value)
      : Vue.set(state, param, value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
